export default __webpack_public_path__ + "static/media/cp-documentCenter.47b94b79.png";